import { render, staticRenderFns } from "./scene-setting.vue?vue&type=template&id=5c9f95bc&scoped=true"
import script from "./scene-setting.vue?vue&type=script&lang=js"
export * from "./scene-setting.vue?vue&type=script&lang=js"
import style0 from "./scene-setting.vue?vue&type=style&index=0&id=5c9f95bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9f95bc",
  null
  
)

export default component.exports